'use client';

import React, { type KeyboardEvent } from 'react';

import Dropdown from '~/components/Dropdown';
import usePopover from '~/hooks/usePopover';

export type PeopleMenuProps = {
  children: React.ReactElement<any, any> | React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
};

export default function PeopleMenu({ content, children, disabled }: PeopleMenuProps) {
  const { id, open, handleClose, handleOpen, anchorEl } = usePopover<HTMLDivElement>();

  if (!content) return children;

  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (disabled) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen(event);
    }
  };

  const trigger = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<{ disableTooltip?: boolean }>, {
        disableTooltip: open,
      })
    : children;

  return (
    <div className="w-full">
      <div
        className="flex w-full items-center"
        onClick={!disabled ? handleOpen : undefined}
        onKeyDown={onKeyDown}
      >
        {trigger}
      </div>
      <Dropdown
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        side="right"
        align="start"
        alignOffset={10}
        disablePortal={false}
      >
        <div
          className="p-0 text-left text-sm font-normal"
          onClick={handleClose}
          role="presentation"
        >
          {content}
        </div>
      </Dropdown>
    </div>
  );
}
